import { render, staticRenderFns } from "./studioDashboardWebsiteContent.vue?vue&type=template&id=72f8d76e"
import script from "./studioDashboardWebsiteContent.vue?vue&type=script&lang=js"
export * from "./studioDashboardWebsiteContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports